// LivestreamScrollHint.js
'use strict';
import { connect } from 'react-redux';

import LivestreamScrollHint from '../component/LivestreamScrollHint.jsx';
import setHasScrollHintDisplayed from '../action/setHasScrollHintDisplayed.js';

const mapDispatchToProps = dispatch => {
  return {
    setHasScrollHintDisplayed: () => dispatch(setHasScrollHintDisplayed()),
  };
};

export default connect(null, mapDispatchToProps)(LivestreamScrollHint);
